module.exports = {
  projectName: 'Application name',
  eng: 'English',
  de: 'German',
  error404: 'The page you are looking for does not exist!',
};



// WEBPACK FOOTER //
// ./src/lang/nl/global.js